import * as React from 'react';
import Rive from '@rive-app/react-canvas';
import styled from 'styled-components';

const Container = styled.div<{ size?: number; }>`
  width: ${(p) => p.size ? `${p.size}px` : '100%'};
  height: ${(p) => p.size ? `${p.size}px` : '100%'};
`;

interface IllustrationMagicProps {
  size?: number;
}

export const IllustrationMagic = (props: IllustrationMagicProps) => {
  const { size } = props;

  return (
    <Container className="illustration-magic" size={size}>
      <Rive src="https://gqefcpylonobj.vcdn.cloud/directus-upload/bd6d2dd9-2ced-44bd-b9ed-d7ffadaf7c44.riv" />
    </Container>
  );
};
